import {action, makeObservable, observable} from "mobx";

export class DocumentStore {
    id = "";
    title = "";
    folderCount = 0;
    lastUpdated = "";
    lastUpdatedTooltip = "";
    owner = "";
    date = "";
    status = "";
    tags = [];
    isSelected = false;
    isHovered = false;
    //data from contract
    document_uuid = "";
    vault_uuid = "";
    name = "";
    created_at = "";
    updated_at = "";
    description = "";
    active = true;
    version = 0;
    scope = "";
    summary = "";
    path = "";
    owner_uuid = "";
    owner_full_name = "";

    constructor({ id, title, folderCount, lastUpdated, lastUpdatedTooltip, owner, date, status, tags, document_uuid, vault_uuid, name, created_at, updated_at, description, active, version, scope, summary, path, owner_uuid, owner_full_name }) {
        makeObservable(this, {
            id: observable,
            title: observable,
            folderCount: observable,
            lastUpdated: observable,
            lastUpdatedTooltip: observable,
            isSelected: observable,
            isHovered: observable,
            setHover: action,
            setSelected: action,
            //data from contract
            document_uuid: observable,
            vault_uuid: observable,
            name: observable,
            created_at: observable,
            updated_at: observable,
            description: observable,
            active: observable,
            version: observable,
            scope: observable,
            summary: observable,
            path: observable,
            owner_uuid: observable,
            owner_full_name: observable,
        });

        this.id = id;
        this.title = title;
        this.folderCount = folderCount;
        this.lastUpdated = lastUpdated;
        this.lastUpdatedTooltip = lastUpdatedTooltip;
        this.owner = owner;
        this.date = date;
        this.status = status;
        this.tags = tags;
        //data from contract
        this.document_uuid = document_uuid;
        this.vault_uuid = vault_uuid;
        this.name = name;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.description = description;
        this.active = active;
        this.version = version;
        this.scope = scope;
        this.summary = summary;
        this.path = path;
        this.owner_uuid = owner_uuid;
        this.owner_full_name = owner_full_name;
    }

    setHover(value){
        this.isHovered = value;
    }

    setSelected(value){
        this.isSelected = value;
    }

    setName(name){
        this.name = name;
    }
}